export const matterTagColorOptions = [
  {
    value: "red",
    label: "Red",
    chipClassName:
      "border-red-300 bg-red-50 text-red-700 dark:border-red-400/30 dark:bg-red-500/15 dark:text-red-300",
    swatchClassName: "bg-red-500",
  },
  {
    value: "orange",
    label: "Orange",
    chipClassName:
      "border-orange-300 bg-orange-50 text-orange-700 dark:border-orange-400/30 dark:bg-orange-500/15 dark:text-orange-300",
    swatchClassName: "bg-orange-500",
  },
  {
    value: "yellow",
    label: "Yellow",
    chipClassName:
      "border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-400/30 dark:bg-amber-500/15 dark:text-amber-300",
    swatchClassName: "bg-amber-400",
  },
  {
    value: "lime",
    label: "Lime",
    chipClassName:
      "border-lime-300 bg-lime-50 text-lime-700 dark:border-lime-400/30 dark:bg-lime-500/15 dark:text-lime-300",
    swatchClassName: "bg-lime-500",
  },
  {
    value: "green",
    label: "Green",
    chipClassName:
      "border-emerald-300 bg-emerald-50 text-emerald-700 dark:border-emerald-400/30 dark:bg-emerald-500/15 dark:text-emerald-300",
    swatchClassName: "bg-emerald-500",
  },
  {
    value: "teal",
    label: "Teal",
    chipClassName:
      "border-teal-300 bg-teal-50 text-teal-700 dark:border-teal-400/30 dark:bg-teal-500/15 dark:text-teal-300",
    swatchClassName: "bg-teal-500",
  },
  {
    value: "cyan",
    label: "Cyan",
    chipClassName:
      "border-cyan-300 bg-cyan-50 text-cyan-700 dark:border-cyan-400/30 dark:bg-cyan-500/15 dark:text-cyan-300",
    swatchClassName: "bg-cyan-500",
  },
  {
    value: "blue",
    label: "Blue",
    chipClassName:
      "border-sky-300 bg-sky-50 text-sky-700 dark:border-sky-400/30 dark:bg-sky-500/15 dark:text-sky-300",
    swatchClassName: "bg-sky-500",
  },
  {
    value: "indigo",
    label: "Indigo",
    chipClassName:
      "border-indigo-300 bg-indigo-50 text-indigo-700 dark:border-indigo-400/30 dark:bg-indigo-500/15 dark:text-indigo-300",
    swatchClassName: "bg-indigo-500",
  },
  {
    value: "violet",
    label: "Violet",
    chipClassName:
      "border-violet-300 bg-violet-50 text-violet-700 dark:border-violet-400/30 dark:bg-violet-500/15 dark:text-violet-300",
    swatchClassName: "bg-violet-500",
  },
  {
    value: "purple",
    label: "Purple",
    chipClassName:
      "border-purple-300 bg-purple-50 text-purple-700 dark:border-purple-400/30 dark:bg-purple-500/15 dark:text-purple-300",
    swatchClassName: "bg-purple-500",
  },
  {
    value: "fuchsia",
    label: "Fuchsia",
    chipClassName:
      "border-fuchsia-300 bg-fuchsia-50 text-fuchsia-700 dark:border-fuchsia-400/30 dark:bg-fuchsia-500/15 dark:text-fuchsia-300",
    swatchClassName: "bg-fuchsia-500",
  },
  {
    value: "pink",
    label: "Pink",
    chipClassName:
      "border-pink-300 bg-pink-50 text-pink-700 dark:border-pink-400/30 dark:bg-pink-500/15 dark:text-pink-300",
    swatchClassName: "bg-pink-500",
  },
  {
    value: "rose",
    label: "Rose",
    chipClassName:
      "border-rose-300 bg-rose-50 text-rose-700 dark:border-rose-400/30 dark:bg-rose-500/15 dark:text-rose-300",
    swatchClassName: "bg-rose-500",
  },
  {
    value: "slate",
    label: "Slate",
    chipClassName:
      "border-slate-300 bg-slate-50 text-slate-700 dark:border-slate-400/30 dark:bg-slate-400/15 dark:text-slate-300",
    swatchClassName: "bg-slate-500",
  },
] as const;

const DEFAULT_MATTER_TAG_CHIP_CLASS_NAME =
  "border-slate-300 bg-slate-50 text-slate-700 dark:border-slate-400/30 dark:bg-slate-400/15 dark:text-slate-300";
const DEFAULT_MATTER_TAG_SWATCH_CLASS_NAME = "bg-slate-500";

const matterTagColorAliases: Record<string, string> = {
  gray: "slate",
  grey: "slate",
};

const normalizeMatterTagColor = (color?: string) => {
  const normalizedColor = color?.trim().toLowerCase() ?? "";
  return matterTagColorAliases[normalizedColor] ?? normalizedColor;
};

export const getMatterTagColorOption = (color?: string) => {
  const normalizedColor = normalizeMatterTagColor(color);
  return matterTagColorOptions.find(
    (option) => option.value === normalizedColor,
  );
};

export const getMatterTagChipClassNames = (color?: string) => {
  return (
    getMatterTagColorOption(color)?.chipClassName ??
    DEFAULT_MATTER_TAG_CHIP_CLASS_NAME
  );
};

export const getMatterTagSwatchClassNames = (color?: string) => {
  return (
    getMatterTagColorOption(color)?.swatchClassName ??
    DEFAULT_MATTER_TAG_SWATCH_CLASS_NAME
  );
};
